import { PROJECT_STAGE_OPTIONS, STATUS_TAG_OPTIONS } from '../../lib/projectMeta';

/**
 * Wizard step 1–4 constants (Design Constitution: Aurora Glass).
 */

/** Legacy: kept for API compatibility only; UI now uses SVG icons from projectIcons.ts */
export const WIZARD_EMOJIS = ['📊', '🤖', '✍️', '🗓', '💬', '🛒', '📱', '💰', '🔍', '⚡', '🌐', '🎯'] as const;

export const WIZARD_CATEGORIES = [
  { value: 'bot',        label: 'Бот / Ассистент' },
  { value: 'miniapp',    label: 'Мини-приложение' },
  { value: 'site',       label: 'Сайт / Лендинг' },
  { value: 'saas',       label: 'SaaS / Сервис' },
  { value: 'marketplace',label: 'Маркетплейс' },
  { value: 'shop',       label: 'Интернет-магазин' },
  { value: 'crm',        label: 'CRM / ERP' },
  { value: 'analytics',  label: 'Аналитика / BI' },
  { value: 'dashboard',  label: 'Дашборд' },
  { value: 'ai',         label: 'AI / ML' },
  { value: 'automation', label: 'Автоматизация' },
  { value: 'fintech',    label: 'Финтех' },
  { value: 'crypto',     label: 'Крипто / Web3' },
  { value: 'edtech',     label: 'EdTech / Курсы' },
  { value: 'health',     label: 'HealthTech' },
  { value: 'hr',         label: 'HR / Рекрутинг' },
  { value: 'realty',     label: 'Недвижимость' },
  { value: 'logistics',  label: 'Логистика' },
  { value: 'media',      label: 'Контент / Медиа' },
  { value: 'game',       label: 'GameDev' },
  { value: 'iot',        label: 'IoT / Hardware' },
  { value: 'security',   label: 'Кибербезопасность' },
  { value: 'integration',label: 'API / Интеграция' },
  { value: 'other',      label: 'Другое' },
] as const;

export const WIZARD_NICHES = [
  // По типу бизнеса
  { value: 'b2b',        label: 'B2B' },
  { value: 'b2c',        label: 'B2C' },
  { value: 'b2g',        label: 'B2G / Госсектор' },
  { value: 'c2c',        label: 'C2C / P2P' },
  { value: 'marketplace',label: 'Маркетплейс' },
  { value: 'platform',   label: 'Платформа' },
  { value: 'startup',    label: 'Стартап' },
  { value: 'enterprise', label: 'Enterprise' },
  { value: 'smb',        label: 'МСБ / Малый бизнес' },
  { value: 'freelance',  label: 'Для фрилансеров' },
  { value: 'agency',     label: 'Агентский бизнес' },
  { value: 'solopreneur',label: 'Для соло-предпринимателей' },
  // По индустрии
  { value: 'beauty',     label: 'Красота / Салоны' },
  { value: 'food',       label: 'Общепит / Доставка' },
  { value: 'retail',     label: 'Ритейл / Торговля' },
  { value: 'legal',      label: 'Юридические услуги' },
  { value: 'accounting', label: 'Бухгалтерия / Финансы' },
  { value: 'travel',     label: 'Туризм / Путешествия' },
  { value: 'auto',       label: 'Авто / Транспорт' },
  { value: 'sport',      label: 'Спорт / Фитнес' },
  { value: 'construction',label: 'Строительство' },
  { value: 'manufacturing',label: 'Производство' },
] as const;

export const WIZARD_AUDIENCE = [
  'Предприниматели',
  'Фрилансеры',
  'Разработчики',
  'Дизайнеры',
  'Маркетологи',
  'Менеджеры проектов',
  'Продажники / Sales',
  'HR / Рекрутеры',
  'Финансисты / Бухгалтеры',
  'Юристы',
  'Врачи / Медицина',
  'Преподаватели',
  'Студенты',
  'Владельцы магазинов',
  'Рестораторы / HoReCa',
  'Контент-мейкеры / Блогеры',
  'Инвесторы / Венчур',
  'Любой бизнес',
] as const;

export const WIZARD_TOOL_GROUPS: { name: string; tools: string[] }[] = [
  {
    name: 'AI & Vibe Coding',
    tools: ['Cursor', 'Lovable', 'Bolt.new', 'v0.dev', 'Windsurf', 'Replit', 'GitHub Copilot', 'Devin'],
  },
  {
    name: 'AI / LLM',
    tools: [
      'Claude API', 'OpenAI API', 'ChatGPT', 'Gemini API', 'Mistral',
      'Llama', 'Perplexity API', 'Cohere', 'Hugging Face',
      'Stable Diffusion', 'DALL-E', 'ElevenLabs', 'Whisper', 'DeepSeek',
    ],
  },
  {
    name: 'No-code / Low-code',
    tools: [
      'n8n', 'Make (Integromat)', 'Zapier', 'Pipedream',
      'Bubble', 'Webflow', 'Tilda', 'Framer', 'Wix',
      'AppScript', 'Glide', 'Softr', 'Notion API', 'Airtable', 'Retool',
    ],
  },
  {
    name: 'Telegram',
    tools: [
      'Telegram Mini App', 'Telegram Bot API', 'Aiogram', 'Telegraf', 'Grammy',
      'python-telegram-bot', 'Pyrogram', 'Telethon',
    ],
  },
  {
    name: 'Frontend',
    tools: [
      'React', 'Next.js', 'Vue', 'Nuxt', 'Svelte', 'SvelteKit',
      'Angular', 'Remix', 'Astro', 'Vite', 'TypeScript', 'JavaScript',
      'Tailwind CSS', 'shadcn/ui', 'Chakra UI', 'Three.js', 'HTML/CSS',
    ],
  },
  {
    name: 'Backend',
    tools: [
      'Node.js', 'Python', 'FastAPI', 'Django', 'Flask', 'Express',
      'NestJS', 'Go (Golang)', 'Rust', 'Java / Spring', 'Kotlin',
      'PHP / Laravel', 'Ruby / Rails', 'GraphQL', 'REST API', 'WebSocket', 'gRPC',
    ],
  },
  {
    name: 'Mobile',
    tools: ['React Native', 'Flutter', 'Swift / iOS', 'Kotlin / Android', 'Expo', 'PWA'],
  },
  {
    name: 'Базы данных',
    tools: [
      'PostgreSQL', 'MySQL', 'SQLite', 'MongoDB', 'Redis',
      'ClickHouse', 'Elasticsearch', 'DynamoDB',
      'Supabase', 'Firebase', 'PocketBase', 'Neon', 'PlanetScale',
      'Prisma', 'Drizzle ORM', 'SQLAlchemy', 'TypeORM',
      'Pinecone', 'Weaviate', 'Qdrant',
    ],
  },
  {
    name: 'Инфраструктура',
    tools: [
      'Docker', 'Kubernetes', 'Nginx', 'Caddy',
      'AWS', 'Google Cloud', 'Azure', 'Yandex Cloud',
      'Vercel', 'Railway', 'Fly.io', 'Render', 'Hetzner', 'VPS',
      'Cloudflare', 'Cloudflare Workers',
      'GitHub Actions', 'CI/CD', 'Linux',
    ],
  },
  {
    name: 'Хранилище / CDN',
    tools: ['AWS S3', 'Cloudflare R2', 'Minio', 'Yandex Object Storage', 'Cloudinary', 'Bunny CDN'],
  },
  {
    name: 'Auth',
    tools: ['Supabase Auth', 'Clerk', 'Auth0', 'Firebase Auth', 'NextAuth', 'JWT', 'OAuth 2.0'],
  },
  {
    name: 'Платежи',
    tools: [
      'ЮКасса (Юmoney)', 'Stripe', 'Tinkoff Оплата', 'CloudPayments',
      'Robokassa', 'Telegram Stars', 'TON / TON Connect', 'Telegram Payments',
    ],
  },
  {
    name: 'Коммуникации',
    tools: ['Twilio', 'SendGrid', 'Resend', 'OneSignal', 'Firebase FCM', 'SMPP / SMS', 'WhatsApp API'],
  },
  {
    name: 'Аналитика / Мониторинг',
    tools: ['Google Analytics', 'Yandex Metrica', 'PostHog', 'Amplitude', 'Mixpanel', 'Grafana', 'Sentry', 'Datadog'],
  },
  {
    name: 'ML / Парсинг',
    tools: ['PyTorch', 'TensorFlow', 'scikit-learn', 'OpenCV', 'LangChain', 'LlamaIndex', 'Pandas', 'Playwright', 'Scrapy'],
  },
  {
    name: 'Web3 / Blockchain',
    tools: ['Solidity', 'TON', 'Ethereum', 'Solana', 'Web3.js', 'Ethers.js', 'IPFS'],
  },
];

export const WIZARD_PROJECT_STAGES = [...PROJECT_STAGE_OPTIONS];

export const WIZARD_STATUSES = [...STATUS_TAG_OPTIONS];

export const WIZARD_DEV_TIMES = [
  { value: 'under2h',  label: 'до 2 ч' },
  { value: '2-8h',     label: '2–8 ч' },
  { value: '1-3d',     label: '1–3 дня' },
  { value: 'week',     label: 'неделя' },
  { value: '1-3m',     label: '1–3 мес' },
  { value: 'month',    label: '3+ мес' },
] as const;

export const PRICE_VISIBLE_STATUSES = new Set(['sale', 'clients']);

/** Popular tools shown by default in TechStack picker */
export const POPULAR_TOOLS = [
  'Claude API', 'OpenAI API', 'Telegram Mini App', 'Aiogram',
  'n8n', 'Make (Integromat)', 'Supabase', 'React', 'Next.js',
  'Python', 'Node.js', 'PostgreSQL', 'Docker', 'Cursor',
  'Bolt.new', 'Lovable', 'ЮКасса (Юmoney)', 'Vercel', 'FastAPI',
];
